__turbopack_context__.v({
  "active": "style-module-scss-module__8-GQzW__active",
  "content": "style-module-scss-module__8-GQzW__content",
  "count": "style-module-scss-module__8-GQzW__count",
  "link": "style-module-scss-module__8-GQzW__link",
  "wrapper": "style-module-scss-module__8-GQzW__wrapper",
});
